var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lead && _vm.items.length)?_c('v-card',{attrs:{"outlined":""}},[_c('v-timeline',{attrs:{"align-top":"","dense":""}},[_vm._l((_vm.items),function(item,index){return [_c(_vm.component(item),{key:index,tag:"component",attrs:{"data":item,"lead-status":_vm.lead.currentStatus,"lead-id":_vm.lead.id}})]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }